import {privateApi} from 'utils/api'
export const getValidOdPair = async (payload: any) => await privateApi.post('/cps/v1/validate-odpair', payload)

export const fetchDimentionalWeightFactor = async (payload) =>
    await privateApi.post('/cps/v1/dimensionalFactor', payload)
